import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import {
  AutocompleteInput,
  Button,
  FormDataConsumer,
  ReferenceInput,
  TextInput,
  required,
  useNotify,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { administrationRequests } from "api/administrationApi";
import { employeeRequests } from "api/employeeApi";

const ClassDialog = ({ campaignId, schoolClass, onSaved }) => {
  const notify = useNotify();
  const isEdit = !!schoolClass?.id;

  const handleConfirm = async data => {
    const payload = {
      topic: data.topic,
      startsAt: data.startsAt,
      endsAt: data.endsAt,
      buildingId: data.buildingId,
      roomId: data.roomId,
      lecturerEmployeeId: data.lecturerEmployeeId,
    };

    if (isEdit) {
      await dataProvider.customRequest(
        doctoralRequests.doctoralSchoolClass(campaignId, schoolClass.id),
        payload,
        "PUT",
      );
    } else {
      await dataProvider.customRequest(
        doctoralRequests.doctoralSchoolClasses(campaignId),
        payload,
        "POST",
      );
    }

    notify(isEdit ? "Занятието е обновено успешно" : "Занятието е добавено успешно", {
      type: "success",
    });
    onSaved();
  };

  return (
    <FormModal
      titleContent={isEdit ? "Редакция на занятие" : "Добавяне на занятие"}
      saveTitle="Запази"
      dialogSize="md"
      onConfirm={handleConfirm}
      defaultValues={
        isEdit
          ? {
              topic: schoolClass.topic,
              startsAt: schoolClass.startsAt,
              endsAt: schoolClass.endsAt,
              buildingId: schoolClass.buildingId,
              roomId: schoolClass.roomId,
              lecturerEmployeeId: schoolClass.lecturerEmployeeId,
            }
          : {}
      }
      triggerButton={
        isEdit ? (
          <Button
            label=""
            startIcon={<EditIcon />}
          />
        ) : (
          <Button
            label="Добави занятие"
            variant="contained"
            startIcon={<AddIcon />}
          />
        )
      }
    >
      <Grid
        container
        spacing={2}
        sx={{ mt: 0 }}
      >
        <Grid
          item
          xs={12}
        >
          <TextInput
            source="topic"
            label="Тема на занятието"
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="startsAt"
            label="Начало"
            validate={required("Задължително")}
            fullWidth
            required
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="endsAt"
            label="Край"
            validate={required("Задължително")}
            fullWidth
            required
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="lecturerEmployeeId"
            reference={employeeRequests.getProfessorsSelect()}
          >
            <AutocompleteInput
              label="Преподавател"
              optionText={record => [record?.firstName, record?.lastName].filter(Boolean).join(" ")}
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              validate={required("Задължително")}
              fullWidth
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="buildingId"
            reference={administrationRequests.getBuildingsSelect()}
          >
            <AutocompleteInput
              label="Сграда"
              optionText="name"
              optionValue="id"
              validate={required("Задължително")}
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              fullWidth
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <FormDataConsumer>
            {({ formData }) =>
              formData?.buildingId ? (
                <ReferenceInput
                  source="roomId"
                  reference={administrationRequests.getRoomsSelect()}
                  filter={{ buildingId: formData.buildingId }}
                >
                  <AutocompleteInput
                    label="Зала"
                    optionText="roomName"
                    optionValue="id"
                    validate={required("Задължително")}
                    filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                    fullWidth
                  />
                </ReferenceInput>
              ) : null
            }
          </FormDataConsumer>
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default ClassDialog;
